module.exports = __webpack_public_path__ + "img/io.ed1add28.svg";